import { Directive, ElementRef, Renderer2, OnDestroy, Input } from '@angular/core';

@Directive({
  selector: '[mdPreventOverflowOnHover]',
})
export class PreventOverflowOnHoverDirective implements OnDestroy {
  @Input() mdPreventOverflowOnHoverZIndex = 9999;

  private originalParent: HTMLElement | null = null;
  private nextSibling: Node | null = null;
  private isMovedToBody = false;
  private unlistenMouseEnter?: () => void;
  private unlistenMouseLeave?: () => void;

  constructor(private elementRef: ElementRef<HTMLElement>, private renderer: Renderer2) {
    this.setupHoverListeners();
  }

  private setupHoverListeners(): void {
    const element = this.elementRef.nativeElement;

    this.unlistenMouseEnter = this.renderer.listen(element, 'mouseenter', () => {
      this.moveToBody();
    });

    this.unlistenMouseLeave = this.renderer.listen(element, 'mouseleave', () => {
      this.moveBack();
    });
  }

  private moveToBody(): void {
    if (this.isMovedToBody) {
      return;
    }

    const element = this.elementRef.nativeElement;
    const rect = element.getBoundingClientRect();

    this.originalParent = element.parentElement;
    this.nextSibling = element.nextSibling;

    this.renderer.setStyle(element, 'position', 'fixed');
    this.renderer.setStyle(element, 'top', `${rect.top}px`);
    this.renderer.setStyle(element, 'left', `${rect.left}px`);
    this.renderer.setStyle(element, 'z-index', `${this.mdPreventOverflowOnHoverZIndex}`);

    this.renderer.appendChild(document.body, element);
    this.isMovedToBody = true;
  }

  private moveBack(): void {
    if (!this.isMovedToBody || !this.originalParent) {
      return;
    }

    const element = this.elementRef.nativeElement;

    this.renderer.removeStyle(element, 'position');
    this.renderer.removeStyle(element, 'top');
    this.renderer.removeStyle(element, 'left');
    this.renderer.removeStyle(element, 'z-index');

    if (this.nextSibling) {
      this.renderer.insertBefore(this.originalParent, element, this.nextSibling);
    } else {
      this.renderer.appendChild(this.originalParent, element);
    }

    this.isMovedToBody = false;
  }

  ngOnDestroy(): void {
    if (this.unlistenMouseEnter) {
      this.unlistenMouseEnter();
    }
    if (this.unlistenMouseLeave) {
      this.unlistenMouseLeave();
    }

    if (this.isMovedToBody) {
      this.moveBack();
    }
  }
}
